import { School } from '../school';
import { ClassType } from '../class-type';
import { Student } from '../student';
import { Location } from '../location';

export class LessonFamily {
    constructor(
        public id?: number,
        public school?: School,
        public dayOfWeek?: string,
        public startDate?: any,
        public endDate?: any,
        public startTime?: any,
        public endTime?: any,
        public startDateTime?: any,
        public endDateTime?: any,
        public minParticipants?: number,
        public maxParticipants?: number,
        public reservationCancellationPolicy?: number,
        public reminderPolicy?: number,
        public classType?: ClassType,
        public teacher?: Student,
        public location?: Location,
        public free?: boolean,
        public videoConference?: boolean
    ) {
    }
}


export class LessonFamilyWithContextDetails extends LessonFamily {
    selected: boolean;
    lessonsCount: number;

    /**
         * Converts a plain LessonFamily into LessonFamilyWithContextDetails
         */
        public static fromLessonFamily(lessonFamily: LessonFamily): LessonFamilyWithContextDetails {
            const enriched = new LessonFamilyWithContextDetails(
                lessonFamily.id,
                lessonFamily.school,
                lessonFamily.dayOfWeek,
                lessonFamily.startDate,
                lessonFamily.endDate,
                lessonFamily.startTime,
                lessonFamily.endTime,
                lessonFamily.startDateTime,
                lessonFamily.endDateTime,
                lessonFamily.minParticipants,
                lessonFamily.maxParticipants,
                lessonFamily.reservationCancellationPolicy,
                lessonFamily.reminderPolicy,
                lessonFamily.classType,
                lessonFamily.teacher,
                lessonFamily.location,
                lessonFamily.free,
                lessonFamily.videoConference
            );
            enriched.selected = false;
            enriched.lessonsCount = 0;
            return enriched;
        }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson-family/lesson-family.model.ts